import styled from 'styled-components'

const ShopSectionStyle = styled.div`
	margin-top: var(--sectionMargin);

	.productsWrap {
		margin: calc(var(--sp1-5x) * -1);
		margin-top: var(--sp13x);
		.otherProductsWrap {
			width: 50.7%;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		.productsWrap {
			margin: calc(var(--spSize) * -1);
			margin-top: var(--sp10x);
			.otherProductsWrap {
				width: 50%;
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		.productsWrap {
			margin: calc(var(--spSize) * -1);
			margin-top: var(--sp8x);
			.otherProductsWrap {
				width: 49.4%;
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		.productsWrap {
			margin: calc(var(--spSize) * -1);
			margin-top: var(--sp7x);
			.otherProductsWrap {
				width: 36.9%;
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		.productsWrap {
			margin: calc(var(--spSize) * -1);
			margin-top: var(--sp7x);
			.bigAndNormal {
				flex-direction: column;
			}
			.otherProductsWrap {
				width: 100%;
			}
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.productsWrap {
			margin: calc(var(--spSize) * -1);
			margin-top: var(--sp5x);
			.bigAndNormal {
				flex-direction: column;
			}

			.otherProductsWrap {
				width: 100%;
			}
		}
	}
`

export default ShopSectionStyle
